import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import CustomhtmlForFeature from 'utils/CustomDefault';
import htmlForFeature from 'utils/htmlForFeature';
import { useEffect, useState } from 'react';

export const SCHOOL_LAYER_ID = 'schoolLayer';

const layerConfig = {
  title: 'Schools',
};

const ICONS = {
    'Public School': require('../../../assets/school.png'),
}; 
function SchoolLayer() {
  const dispatch = useDispatch();
  const { schoolLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, schoolLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });
   const viewState = useSelector((state) => state.carto.viewState);
  const [isShow, setIsShow] = useState(false);
    useEffect(() => {
    if (viewState.zoom > 12) {
      setIsShow(true);
    } else setIsShow(false);
  }, [viewState]);

  if (schoolLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: SCHOOL_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: schoolLayer.visible,
      opacity: schoolLayer.opacity,

      pointType: 'icon',
      getIcon : () => ( {
        url: require('../../../assets/school.png'),
        width: 128,
        height: 128,
        anchorY: 128
      }),
      getIconSize: () => 12,
      iconSizeUnits: 'pixels',
      iconSizeScale: 2,
      iconBillboard: true,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: SCHOOL_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
            }),
          };
        }
      }
    });
  }
}

export default SchoolLayer;
